import React from 'react'

const VerificationCodeContext = React.createContext('')

export default VerificationCodeContext
